import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import {
  Select,
  MenuItem,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  TableBody,
  Table,
} from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos, FirstPage, LastPage } from '@mui/icons-material';

import { EAA_Add_Btn } from '~/components/EditAndAddItem';
import { T_TitleCell, T_Btn_Function, T_TableRow } from '~/components/TableItem';

import T_common from '~/components/TableItem/common';
import CheckDelete from '~/components/Dialog/CheckDelete';
import AddAndEdit from './AddAndEdit';

class MaritimeList extends Component {
  state={
    per_page: 5,
    page: 1,

    sort: true,
    sort_field: 'upd_time',
    view_checkDelete: false,
    view_addAndEdit: false,
    mode_addAndEdit: '',
    currentId: '',
    currentAct: '',
  }

  componentDidMount () {
    // const { status, keyword, org_id } = this.state;
    // this.data = { status, keyword, org_id };
    this.refresh();
  }

  refresh=() => {
    const { page, per_page, sort, sort_field } = this.state;
    // const { status, keyword, org_id } = this.data;
    this.props.getIAOverviewMaritimeList({
      page,
      per_page,
      body: {
      // keyword,
      // org_id: org_id === '0' ? '' : org_id,
        sort: sort ? 'desc' : 'asc',
        sort_field,
      // status: status === '3' ? '' : status,
      },
    });
  }

  onExport=() => {
    const { windfield_name } = this.props;
    const { page, per_page, sort, sort_field } = this.state;
    Actions_Wind.exportIAOverviewMaritimeList(
      {
        page,
        per_page,
        body: {
          sort: sort ? 'desc' : 'asc',
          sort_field,
        },
      },
      `${windfield_name}_海事工程服務`,
    );
  }

  search=() => this.setState({ page: 1 }, () => this.refresh());

  _click_search=() => {
    const { status, keyword, org_id, sort, sort_field } = this.state;
    this.data = { status, keyword, org_id, sort, sort_field };
    this.search();
  }

  _delete=(id, act) => this.setState({ currentId: id, currentAct: act, view_checkDelete: true })
  _close_view_checkDelete=() => {
    // this.refresh();
    this.setState({ currentId: '', currentAct: '', view_checkDelete: false });
  }

  _add=() => this.setState({ view_addAndEdit: true, mode_addAndEdit: 'add' })
  _view=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'view' })
  _edit=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'edit' })
  _close_view_addAndEdit=() => {
    this.refresh();
    this.setState({ currentId: '', view_addAndEdit: false, mode_addAndEdit: '' });
  }

  renderTableTitle=() => {
    const { sort, sort_field } = this.state;
    const onChangeSort = t => {
      this.setState({ sort_field: t, sort: sort_field === t ? !sort : false }, () => this.search());
    };
    const ary = [
      { name: '序號' },
      { name: '項目' },
      { name: '承包商' },
      { name: '數量(單位)' },
      { name: '辦理狀態' },
      { name: '檢附國內無產製' },
      { name: '功能' },
    ];
    return (
      <TableHead>
        <TableRow style={{ height: 48 }}>
          {ary.map((o, i) => (
            <T_TitleCell
              key={i}
              text={o.name}
              arrow={!!o.id}
              bol={sort_field === o.id ? sort : true}
              onClick={() => onChangeSort(o.id)}
            />
          ))}
        </TableRow>
      </TableHead>
    );
  }

  renderTableBody=() => {
    const { IAOverviewMaritimeList = {} } = this.props;
    const { list = [], page = 0, total = 0, per_page = 0 } = IAOverviewMaritimeList;
    const cellStyle = { fontSize: 14 };
    let start = 0;
    if (page > 0) {
      start = (page - 1) * per_page + 1;
      if (start > total)start = 0;
    }
    return (
      <TableBody>
        {list.map((o, i) => (
          <T_TableRow key={i} backgroundColor= {i % 2 === 0 ? '#E0FDFF' : 'white'}>
            <TableCell align='center' style={cellStyle}>{i + start}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.project}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.partner || '-'}</TableCell>
            <TableCell align='center' style={cellStyle}>{`${o.provide_num || '-'} 艘`}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.select_data_type || '-'}</TableCell>
            <TableCell align='center' style={cellStyle}>{(o.have_doc === '1') ? '有' : '無'}</TableCell>
            <TableCell style={{ width: 214 }}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                <T_Btn_Function
                  text='檢視'
                  backgroundColor={T_common.type1}
                  onClick={() => this._view(o.id)}
                />
                <T_Btn_Function
                  text='編輯'
                  backgroundColor={T_common.type2}
                  onClick={() => this._edit(o.id)}
                  style={{ marginLeft: 8, marginRight: 8 }}
                  // disabled={!canEdit}
                />
                <T_Btn_Function
                  text='刪除'
                  backgroundColor={T_common.type3}
                  onClick={() => this._delete(o.id, o.project)}
                  // disabled={!canDel}
                />
              </div>
            </TableCell>
          </T_TableRow>
        ))}
      </TableBody>
    );
  }

  renderTableBar=() => {
    const { IAOverviewMaritimeList = {} } = this.props;
    const { has_next = false, has_prev = false, page = 0, pages = 0, total = 0 } = IAOverviewMaritimeList;
    const { per_page, page: statePage } = this.state;
    const returnPages = () => {
      const array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      return array;
    };
    const returnPers = () => [5, 10, 20, 30, 40];
    const canFirst = page > 1;
    const canLast = page < pages;
    return (
      <div style={{ height: 48, display: 'flex', alignItems: 'center', width: '98%', backgroundColor: 'white', borderBottomRightRadius: 8, borderBottomLeftRadius: 8, paddingTop: 6, paddingBottom: 6 }}>
        <div style={{ flex: 1 }} />
        <FirstPage style={{ height: 24, width: 24, color: canFirst ? 'black' : 'gray', cursor: canFirst ? 'pointer' : 'default' }} onClick={() => { if (canFirst) this.setState({ page: 1 }, () => this.refresh()); }} />
        <ArrowBackIos style={{ marginLeft: 3, marginRight: 5, height: 16, width: 16, color: has_prev ? 'black' : 'gray', cursor: has_prev ? 'pointer' : 'default' }} onClick={() => { if (has_prev) this.setState({ page: this.state.page - 1 }, () => this.refresh()); }} />
        <div style={{ fontSize: 14 }}>第</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px', marginRight: 8, marginLeft: 8 }}
          variant="outlined"
          value={statePage}
          onChange={e => this.setState({ page: e.target.value }, () => { this.refresh(); })}
        >
          {returnPages().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginRight: 8 }}>{`/${pages} 頁，每頁`}</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px' }}
          variant="outlined"
          value={per_page}
          onChange={e => this.setState({ per_page: e.target.value }, () => { this.search(); })}
        >
          {returnPers().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginLeft: 8 }}>{`筆，共${total}筆`}</div>
        <ArrowForwardIos style={{ marginLeft: 5, height: 16, width: 16, color: has_next ? 'black' : 'gray', cursor: has_next ? 'pointer' : 'default' }} onClick={() => { if (has_next) this.setState({ page: this.state.page + 1 }, () => this.refresh()); }} />
        <LastPage style={{ marginRight: 19, height: 24, width: 24, color: canLast ? 'black' : 'gray', cursor: canLast ? 'pointer' : 'default' }} onClick={() => { if (canLast) this.setState({ page: pages }, () => this.refresh()); }} />
        <div style={{ flex: 1 }} />
      </div>
    );
  }

  renderTable=() => {
    const { IAOverviewMaritimeList = {} } = this.props;
    const { list = [] } = IAOverviewMaritimeList;
    const haveData = list.length > 0;
    return (
      <TableContainer style={{ marginTop: 18, maxWidth: '98%' }}>
        <Table style={{ backgroundColor: 'white', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
          {this.renderTableTitle()}
          {haveData && this.renderTableBody()}
        </Table>
      </TableContainer>
    );
  }

  render () {
    const { IAOverviewMaritimeList = {}, deleteIAOverviewMaritime } = this.props;
    const { currentId, view_checkDelete, currentAct, view_addAndEdit, mode_addAndEdit } = this.state;
    const { list = [] } = IAOverviewMaritimeList;
    const haveData = list.length > 0;

    return (
      <div style={{ width: '100%' }}>
        <div style={{ marginTop: 24, display: 'flex', alignItems: 'center' }}>
          <div style={{ color: '#064B6F', fontSize: 20, lineHeight: '24px', letterSpacing: '0.25%' }}>海事工程服務</div>
        </div>
        <div style={{ marginTop: 12, display: 'flex' }}>
          <EAA_Add_Btn
            onClick={this._add}
            // disabled={!canAdd}
            marginRight={12}
          />
          <EAA_Add_Btn text='匯出資料' onClick={this.onExport} />
        </div>
        {this.renderTable()}
        {haveData && this.renderTableBar()}
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        {view_addAndEdit && <AddAndEdit id={currentId} mode={mode_addAndEdit} _onClose={this._close_view_addAndEdit} />}
        <CheckDelete
          open={view_checkDelete}
          text={`項目：${currentAct}`}
          onClose={this._close_view_checkDelete}
          search={this.search}
          resKey='DeleteIAOverviewMaritime'
          onDelete={() => { deleteIAOverviewMaritime(currentId); }}
        />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  IAOverviewMaritimeList: state.data.IAOverviewMaritimeList,
  windfield_name: state.data.WindIdDetail?.windfield_name,
});
const mapDispatchToProps = dispatch => ({
  getIAOverviewMaritimeList: body => Actions_Wind.getIAOverviewMaritimeList(dispatch, body),
  deleteIAOverviewMaritime: id => Actions_Wind.deleteIAOverviewMaritime(dispatch, { id }),
});

export default connect(mapStateToProps, mapDispatchToProps)(MaritimeList);
